import type { GetNodeSlotId } from "@skilitics/nautilus-core-designer-data";

interface CreateOptions {
  getSlotId: GetNodeSlotId;
}

export type GetNodeAncestorIds = (id: number) => number[];

export const getNodeAncestorIdsCreate =
  ({ getSlotId }: CreateOptions): GetNodeAncestorIds =>
  (startId) => {
    const ancestorIds: number[] = [];

    const populateAncestors = (id: number) => {
      const slotId = getSlotId(id);
      if (!slotId) return;

      ancestorIds.push(slotId.parentId);
      populateAncestors(slotId.parentId);
    };

    populateAncestors(startId);

    return ancestorIds;
  };
